import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminCredentialsSelection from './UseOrgUnitAdminCredentialsSelection';

import OrgUnitAdminCredentialsSelectionGrid from './OrgUnitAdminCredentialsSelectionGrid';

import CredentialTypeDropdown from '../../../../components/dropdowns/CredentialTypeDropdown';

import Input from '@usas/ui-web/components/inputs/Input';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

import Constants from '@usas/ui-web/utils/Constants';

const OrgUnitAdminCredentialsSelection = () => {
  const { gridState, omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState, credentialTypeState, onSelectAll, onUnselectAll,
    onSaveClicked, onBackClicked, onCheckboxChange, onFilterClicked, onClearFilterClicked,
    onFormValueChanged, onValueTextPairChanged, formState, errorState
  } = useOrgUnitAdminCredentialsSelection();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_CREDENTIALS_SELECTION}
        onNextButtonClicked={onSaveClicked}
        onBackButtonClicked={onBackClicked}
        errorMessage={errorState.general}>
        <form>
          <div className='row'>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <CredentialTypeDropdown
                label="Credential*"
                name="credentialTypeId"
                value={formState.credentialTypeId}
                error={errorState.credentialTypeId}
                message={errorState.credentialTypeId}
                onChange={(value, newValueLabel, e) => {
                  e && e.target && e.target.value &&
                    onValueTextPairChanged(value, 'credentialTypeId', newValueLabel, 'credentialTypeName')
                }}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="First or Preferred Name"
                name="firstOrPreferredName"
                value={formState.firstOrPreferredName}
                error={errorState.firstOrPreferredName}
                message={errorState.firstOrPreferredName}
                onChange={(value) => { onFormValueChanged('firstOrPreferredName', value) }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="Last Name"
                name="lastName"
                value={formState.lastName}
                error={errorState.lastName}
                message={errorState.lastName}
                onChange={(value) => { onFormValueChanged('lastName', value) }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="Member Id"
                name="memberId"
                value={formState.memberId}
                error={errorState.memberId}
                message={errorState.memberId}
                onChange={(value) => { onFormValueChanged('memberId', value) }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="Email"
                name="email"
                value={formState.email}
                error={errorState.email}
                message={errorState.email}
                onChange={(value) => { onFormValueChanged('email', value) }} />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <YesNoSwitch
                label="Is In Good Standing?"
                name="isInGoodStanding"
                checked={formState.isInGoodStanding}
                error={errorState.isInGoodStanding}
                message={errorState.isInGoodStanding}
                onChange={(value) => { onFormValueChanged('isInGoodStanding', value) }} />
            </div>
            {errorState.filter &&
              <div className="col-xs-12">
                <p className={global.ErrorMessage}>{errorState.filter ? errorState.filter : ''}</p>
              </div>
            }
            <div className='col-xs-6 col-sm-2'>
              <button className={global.PlainButton} onClick={(e) => onFilterClicked(e)}>Filter</button>
            </div>
            <div className='col-xs-6 col-sm-4'>
              <button className={global.PlainButton} onClick={(e) => onClearFilterClicked(e)}>Clear Filter</button>
            </div>
          </div>
        </form>
        {gridState.gridData.length > 5 && omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading === false &&
          <div className='visible-md visible-lg'>
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onUnselectAll}>Unselect All Results</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={onSelectAll}>Select All Results</PrimaryButton>
                </div>
              </div>
            </div>
            {errorState.general &&
              <div className="row usas-extra-top-margin">
                <div className="col-xs-12 usas-extra-top-margin">
                  <p className={[global.ErrorMessage, global.Multiline].join(' ')}>{errorState.general}</p>
                </div>
              </div>}
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={onSaveClicked}>Save</PrimaryButton>
                </div>
              </div>
            </div>
          </div>}
        {gridState.gridData.length > 0 && omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading === false &&
          <div className='hidden-md hidden-lg'>
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onUnselectAll}>Unselect All Results</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={onSelectAll}>Select All Results</PrimaryButton>
                </div>
              </div>
            </div>
            {errorState.general &&
              <div className="row usas-extra-top-margin">
                <div className="col-xs-12 usas-extra-top-margin">
                  <p className={[global.ErrorMessage, global.Multiline].join(' ')}>{errorState.general}</p>
                </div>
              </div>}
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={onSaveClicked}>Save</PrimaryButton>
                </div>
              </div>
            </div>
          </div>}
        <div className='row usas-extra-top-margin'>
          <div className="col-xs-12">
            <OrgUnitAdminCredentialsSelectionGrid
              gridData={gridState.gridData}
              isLoading={omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading}
              onCheckboxChange={onCheckboxChange}
            />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <div className={style.FloatRight}>
              <SecondaryButton type="button" onClick={onUnselectAll}>Unselect All Results</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={onSelectAll}>Select All Results</PrimaryButton>
            </div>
          </div>
        </div>
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading || credentialTypeState.isArrayLoading} />
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isSaving} />
      </ViewTemplate>
    </Fragment >
  );
};

export default OrgUnitAdminCredentialsSelection;